
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const SapDangersPage = lazy(() => import('../pages/sap-dangers/page'));
const CrowdfundingPage = lazy(() => import('../pages/crowdfunding-eng/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sap-dangers',
    element: <SapDangersPage />,
  },
  {
    path: '/crowdfunding',
    element: <CrowdfundingPage />,
  },
  {
    path: '/technology',
    element: <TechnologyPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;